import * as Remix from "react-icons/ri"

export const RemixIconList = {
  Add: Remix.RiAddLine,
  ArrowDown: Remix.RiArrowDownLine,
  ArrowDownS: Remix.RiArrowDownSLine,
  ArrowLeft: Remix.RiArrowLeftLine,
  ArrowLeftRight: Remix.RiArrowLeftRightLine,
  ArrowLeftS: Remix.RiArrowLeftSLine,
  ArrowRight: Remix.RiArrowRightLine,
  ArrowRightS: Remix.RiArrowRightSLine,
  ArrowUp: Remix.RiArrowUpLine,
  ArrowUpDown: Remix.RiArrowUpDownLine,
  ArrowUpS: Remix.RiArrowUpSLine,
  Article: Remix.RiArticleLine,
  BallPen: Remix.RiBallPenFill,
  BankCard: Remix.RiBankCard2Line,
  BarChart: Remix.RiBarChart2Line,
  Bookmark: Remix.RiBookmark3Line,
  Building: Remix.RiBuildingLine,
  Calculator: Remix.RiCalculatorLine,
  Calendar: Remix.RiCalendarLine,
  Chat: Remix.RiChat3Line,
  Check: Remix.RiCheckLine,
  Close: Remix.RiCloseLine,
  ContactsBook: Remix.RiContactsBookLine,
  Download: Remix.RiDownloadLine,
  ErrorWarning: Remix.RiErrorWarningLine,
  EuroBox: Remix.RiMoneyEuroBoxLine,
  Exchange: Remix.RiExchangeLine,
  Eye: Remix.RiEyeLine,
  EyeOff: Remix.RiEyeOffLine,
  ExternalLinkLine: Remix.RiExternalLinkLine,
  Facebook: Remix.RiFacebookFill,
  FileCopy: Remix.RiFileCopyLine,
  FileText: Remix.RiFileTextLine,
  Hammer: Remix.RiHammerLine,
  Home: Remix.RiHome3Line,
  Information: Remix.RiInformationLine,
  Instagram: Remix.RiInstagramLine,
  Leaf: Remix.RiLeafLine,
  Lightbulb: Remix.RiLightbulbLine,
  LineChart: Remix.RiLineChartLine,
  Link: Remix.RiLinkM,
  Linkedin: Remix.RiLinkedinFill,
  Lock: Remix.RiLockLine,
  Mastercard: Remix.RiMastercardLine,
  Menu: Remix.RiMenuLine,
  Percent: Remix.RiPercentLine,
  Phone: Remix.RiPhoneLine,
  PhoneLock: Remix.RiPhoneLockLine,
  PieChart: Remix.RiPieChartLine,
  Pin: Remix.RiMapPinLine,
  Question: Remix.RiQuestionLine,
  Search: Remix.RiSearchLine,
  SecurePayment: Remix.RiSecurePaymentLine,
  Share: Remix.RiShareLine,
  ShareBox: Remix.RiShareBoxLine,
  ShieldCheck: Remix.RiShieldCheckLine,
  Smartphone: Remix.RiSmartphoneLine,
  Subtract: Remix.RiSubtractLine,
  Survey: Remix.RiSurveyLine,
  SwapBox: Remix.RiSwapBoxLine,
  Time: Remix.RiTimeLine,
  TwitterX: Remix.RiTwitterXFill,
  User: Remix.RiUser3Line,
  Visa: Remix.RiVisaLine,
  Wallet: Remix.RiWallet3Line,
  Whatsapp: Remix.RiWhatsappLine,
  Youtube: Remix.RiYoutubeLine,
  YoutubeFill: Remix.RiYoutubeFill,
  Earth: Remix.RiEarthLine,
  Briefcase: Remix.RiBriefcase4Line,
  CalendarCheck: Remix.RiCalendarCheckLine,
  Checkbox: Remix.RiCheckboxLine,
  CloseCircleFill: Remix.RiCloseCircleFill,
  Community: Remix.RiCommunityLine,
  Coupon: Remix.RiCoupon3Line,
  Equalizer: Remix.RiEqualizerLine,
  HandCoin: Remix.RiHandCoinLine,
  HandHeart: Remix.RiHandHeartLine,
  Heart: Remix.RiHeartLine,
  HeartFill: Remix.RiHeartFill,
  HeartPulse: Remix.RiHeartPulseLine,
  ListCheck: Remix.RiListCheck3,
  MailSend: Remix.RiMailSendLine,
  MailVolume: Remix.RiMailVolumeLine,
  Presentation: Remix.RiPresentationLine,
  Service: Remix.RiServiceLine,
  ShakeHands: Remix.RiShakeHandsLine,
  Twitter: Remix.RiTwitterXLine,
  CheckboxCircle: Remix.RiCheckboxCircleLine,
  MapPin2: Remix.RiMapPin2Line,
  Bank: Remix.RiBankLine,
}

function isIconNameValid(
  iconName: string
): iconName is keyof typeof RemixIconList {
  return iconName in RemixIconList
}

function isRemixIconValid(iconName: string): iconName is keyof typeof Remix {
  return iconName in Remix
}

export function getIconComponent(name: string) {
  if (isIconNameValid(name)) {
    return RemixIconList[name]
  } else if (isRemixIconValid(name)) {
    return Remix[name]
  } else {
    console.warn(
      `Icon "${name}" not found in RemixIconList or Remix. Please check the icon name.`
    )
    return null
  }
}
